/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
import { useState, useEffect } from 'react';
import { FiArrowRight, FiBriefcase, FiChevronDown, FiExternalLink } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import { Helmet } from "react-helmet";

const Portfolio = () => {


    const portfolioItems = ([
        {
            _id: "1",
            title: "Digital Identity",
            category: "Web Development",
            year: "2026",
            client: "Alexander Johnson",
            description: "A sleek, modern website showcasing a personal brand with a focus on design and user experience.",
            image: "Alex.png",
            alt: "Personal digital Identity",
            url: "https://degital-identity.vercel.app/"
        },
        {
            _id: "2",
            title: "E-Commerce Platform",
            category: "Shopify Development",
            year: "2025",
            client: "vrumi vedic",
            description: "A fully customized e-commerce solution with advanced product filtering.",
            image: "vrumi.png",
            alt: "E-commerce website on multiple devices",
            url: "https://vrumivedic.com/"
        },
        {
            _id: "3",
            title: "B2B Platform",
            category: "Custom Web Development",
            year: "2025",
            client: "Shree Pakodiz",
            description: "A fully customized B2B platform.",
            image: "shreepakodiz.png",
            alt: "Fully Costomized B2B platform",
            url: "https://shreepakodiz.in/"
        },
        {
            _id: "4",
            title: "Fully Customized It company website",
            category: "Web Development",
            year: "2023",
            client: "Shreekhodiyar tech",
            description: "A fully customized website for an IT company, showcasing their services, portfolio, and team.",
            image: "shreekhodiyar.png",
            alt: "Fully Customized It company website",
            url: "https://shreekhodiyartech.com/"
        },
        {
            _id: "5",
            title: "digital Identity demo for jekil",
            category: "Digital Identity",
            year: "2026",
            client: "Jekil Satani",
            description: "A sleek, modern website showcasing a personal brand with a focus on design and user experience.",
            image: "jekildi.png",
            alt: "Personal digital Identity demo for jekil",
            url: "https://jekilsatani-digitalidentity.vercel.app/"
        },
        {
            _id: "6",
            title: "digital Identity demo for jigar",
            category: "Digital Identity",
            year: "2026",
            client: "Jigar vaghani",
            description: "A sleek, modern website showcasing a personal brand with a focus on design and user experience.",
            image: "jigardi.png",
            alt: "Personal digital Identity demo for jigar",
            url: "https://jigar-vaghani-digital-identity.vercel.app/"
        },
    ])


    // useEffect(() => {
    //     const fetchPortfolios = async () => {
    //         try {
    //             setIsLoading(true);
    //             const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/uni/portfolio/publishedportfolio`);
    //             setPortfolioItems(response.data.data || portfolioItemsTemp);
    //         } catch (error) {
    //             console.error('Error fetching portfolio:', error);
    //             setPortfolioItems(portfolioItemsTemp);
    //         }
    //     };

    //     fetchPortfolios();
    // }, [portfolioItemsTemp]);


    // const filteredProjects = activeCategory === 'All'
    //     ? portfolioItems
    //     : portfolioItems.filter(project => project.category === activeCategory);

    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
            <Helmet>
                <title>Our Work & Portfolio | Game, Web & App Development Projects</title>
                <meta
                    name="description"
                    content="Explore UniTechnoStack's portfolio showcasing game development, web design, mobile apps, and custom software projects delivered for global clients."
                />
                <meta
                    name="keywords"
                    content="game development projects, web design portfolio, mobile apps, custom software, UniTechnoStack work"
                />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href="https://www.unitechnostack.com/work" />
                <meta property="og:title" content="Our Work | Game, Web & App Development Projects" />
                <meta property="og:description" content="Explore UniTechnoStack's portfolio of game development, web design, mobile apps, and software solutions built for global businesses." />
                <meta property="og:url" content="https://www.unitechnostack.com/work" />
                <meta property="og:type" content="website" />
            </Helmet>

            {/* Hero Section */}
            <section className="h-screen relative py-16 md:py-24 overflow-hidden bg-gradient-to-br from-blue-900 to-purple-900 text-white flex items-center justify-center">

                <div className="absolute inset-0 opacity-20">
                    <div className="absolute top-1/4 left-10 w-72 h-72 bg-purple-600 rounded-full mix-blend-soft-light filter blur-xl animate-pulse"></div>
                    <div className="absolute top-1/2 right-10 w-72 h-72 bg-cyan-500 rounded-full mix-blend-soft-light filter blur-xl animate-pulse animation-delay-2000"></div>
                    <div className="absolute bottom-0 left-1/2 w-72 h-72 bg-blue-600 rounded-full mix-blend-soft-light filter blur-xl animate-pulse animation-delay-4000"></div>
                </div>

                <div className="md:container mx-auto px-4 relative z-10 text-center">
                    <motion.h1
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6"
                    >
                        Crafting <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-400">Digital Experiences</span>
                    </motion.h1>
                    <motion.p
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        className="text-xl text-gray-200 mb-10 max-w-2xl mx-auto"
                    >
                        Where pixels meet purpose, and code transforms into captivating journeys. Each project is a canvas for innovation and human connection.
                    </motion.p>
                    <motion.div
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="inline-block"
                    >
                        <a
                            href="#explore"
                            className="bg-white text-blue-700 px-8 py-3 rounded-lg font-bold text-lg transition-colors flex items-center gap-2 hover:bg-gray-100"
                        >
                            Explore Our Work<FiArrowRight />
                        </a>
                    </motion.div>
                </div>
                {/* Floating Settings Icons Background */}
                <div className="absolute inset-0 overflow-hidden opacity-1000 pointer-events-none">
                    {[...Array(50)].map((_, i) => (
                        <motion.div
                            key={i}
                            animate={{
                                rotate: 360,
                                y: [0, Math.random() * 60 - 30],
                                x: [0, Math.random() * 40 - 20]
                            }}
                            transition={{
                                duration: 30 + Math.random() * 30,
                                repeat: Infinity,
                                ease: "linear",
                                repeatType: "loop"
                            }}
                            className="absolute text-blue-400/20"
                            style={{
                                fontSize: `${Math.random() * 24 + 16}px`,
                                top: `${Math.random() * 100}%`,
                                left: `${Math.random() * 100}%`,
                            }}
                        >
                            <FiBriefcase className="w-full h-full" />
                        </motion.div>
                    ))}
                </div>
                {/* Subtle scroll indicator */}
                <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
                    <FiChevronDown className="text-gray-400 w-8 h-8" />
                </div>

                {/* CSS for animations */}
                <style jsx>{`
    @keyframes float-slow {
      0%, 100% { transform: translate(0, 0) rotate(0deg); }
      50% { transform: translate(20px, 30px) rotate(5deg); }
    }
    @keyframes float-medium {
      0%, 100% { transform: translate(0, 0) rotate(0deg); }
      50% { transform: translate(-15px, -20px) rotate(-3deg); }
    }
    @keyframes gradient-shift {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }
    .animate-float-slow { animation: float-slow 15s ease-in-out infinite; }
    .animate-float-medium { animation: float-medium 12s ease-in-out infinite; }
    .animate-gradient-shift { 
      background-size: 200% 200%;
      animation: gradient-shift 8s ease infinite; 
    }
  `}</style>
            </section>

            {/* Portfolio Section */}
            <section id="explore" className="py-16 px-4">
                <div className="max-w-7xl mx-auto">
                    {/* Section Header */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: true }}
                        className="text-center mb-12"
                    >
                        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
                            Our <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600">Portfolio</span>
                        </h2>
                        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                            Explore some of our recent projects and see how we've helped businesses transform their digital presence.
                        </p>
                    </motion.div>


                    {/* Portfolio Grid */}
                    <motion.div
                        layout
                        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
                    >
                        <AnimatePresence>
                            {portfolioItems.map((item, index) => (
                                <motion.div
                                    key={item._id}
                                    layout
                                    initial={{ opacity: 0, scale: 0.8 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    exit={{ opacity: 0, scale: 0.8 }}
                                    transition={{ duration: 0.4, delay: index * 0.1 }}
                                    whileHover={{ y: -10 }}
                                    className="bg-white rounded-2xl shadow-xl overflow-hidden group cursor-pointer"
                                    onClick={() => window.open(item.url, '_blank')}
                                >
                                    {/* Image Container */}
                                    <div className="relative h-56 overflow-hidden bg-gray-200">
                                        <img
                                            src={item.image}
                                            alt={item.alt}
                                            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                                            <span className="text-white font-medium flex items-center">
                                                View Project <FiExternalLink className="ml-2" />
                                            </span>
                                        </div>
                                    </div>

                                    {/* Content */}
                                    <div className="p-6">
                                        <div className="flex justify-between items-start mb-2">
                                            <h3 className="text-xl font-bold text-gray-800">{item.title}</h3>
                                            <span className="text-sm text-gray-500">{item.year}</span>
                                        </div>
                                        <p className="text-sm text-blue-600 font-medium mb-2">{item.category}</p>
                                        <p className="text-sm text-gray-500 mb-3">Client: {item.client}</p>
                                        <p className="text-gray-600 text-sm line-clamp-3">{item.description}</p>
                                    </div>

                                    {/* Bottom gradient accent */}
                                    <div className="h-1 w-full bg-gradient-to-r from-blue-500 to-purple-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
                                </motion.div>
                            ))}
                        </AnimatePresence>
                    </motion.div>


                </div>
            </section>

            {/* Process Section */}
            <section className="py-16 px-4 bg-gray-50">
                <div className="md:container mx-auto">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl md:text-4xl font-bold mb-4">
                            Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">Proven</span> Process
                        </h2>
                        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                            How we deliver exceptional results every time
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {[
                            {
                                title: 'Discovery',
                                description: 'Deep dive into your business objectives and user needs',
                                icon: '🔍',
                                color: 'from-blue-500 to-cyan-500'
                            },
                            {
                                title: 'Strategy',
                                description: 'Data-driven approach to solving core challenges',
                                icon: '♟️',
                                color: 'from-purple-500 to-pink-500'
                            },
                            {
                                title: 'Execution',
                                description: 'Agile development with continuous feedback loops',
                                icon: '⚡',
                                color: 'from-green-500 to-teal-500'
                            },
                            {
                                title: 'Optimization',
                                description: 'Iterative improvements based on real metrics',
                                icon: '📈',
                                color: 'from-orange-500 to-red-500'
                            },
                        ].map((step, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                viewport={{ once: true, margin: "-100px" }}
                                className="bg-white p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-all duration-300"
                            >
                                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-4 bg-gradient-to-r ${step.color} text-white text-2xl`}>
                                    {step.icon}
                                </div>
                                <h3 className="text-xl font-bold mb-2 text-gray-800">{step.title}</h3>
                                <p className="text-gray-600">{step.description}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-16 px-4">
                <div className="md:container mx-auto">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true, margin: "-100px" }}
                        className="bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-2xl p-8 md:p-12 text-center max-w-4xl mx-auto shadow-xl"
                    >
                        <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Create Something Amazing?</h2>
                        <p className="text-xl mb-8 max-w-2xl mx-auto">
                            Let's discuss how we can help you achieve your business goals with our expertise.
                        </p>
                        <div className="flex flex-wrap justify-center gap-4">
                            <motion.a
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                href="/quickenquiry"
                                className="inline-block bg-white text-blue-600 px-8 py-3 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors"
                            >
                                Get Started Today
                            </motion.a>

                        </div>
                    </motion.div>
                </div>
            </section>
        </div>
    );
};

export default Portfolio;